import { cn } from "@nexxt/ui";
import { useEffect, useState } from "react";
import { m } from "../../paraglide/messages.js";

// Where the visitor is on the way out (ADR-286): the rings in the order of the page, from the inside to the outside.
// From `lg`, beside the page; the section most on screen is the current one.
const stops = [
  { id: "map", app: "world", label: m.nav_map },
  { id: "backstage", app: "backstage", label: m.nav_backstage },
  { id: "guestlist", app: "guestlist", label: m.nav_guestlist },
  { id: "atelier", app: "atelier", label: m.nav_atelier },
  { id: "frontrow", app: "frontrow", label: m.nav_frontrow },
  { id: "outside", app: "world", label: m.nav_outside },
];

export function JourneyRail() {
  const [current, setCurrent] = useState<string | null>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) if (entry.isIntersecting) setCurrent(entry.target.id);
      },
      { rootMargin: "-45% 0px -45% 0px" },
    );
    for (const stop of stops) {
      const section = document.getElementById(stop.id);
      if (section) observer.observe(section);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <nav className="rail" aria-label={m.rail_label()}>
      <span className="rail-end">{m.rail_inside()}</span>
      <ol>
        {stops.map((stop) => (
          <li key={stop.id} data-app={stop.app}>
            <a
              href={`#${stop.id}`}
              className={cn(current === stop.id && "is-current")}
              aria-current={current === stop.id ? "location" : undefined}
            >
              <i />
              <span>{stop.label()}</span>
            </a>
          </li>
        ))}
      </ol>
      <span className="rail-end">{m.rail_outside()}</span>
    </nav>
  );
}
